import pluralize from 'pluralize'
import uniq from 'lodash/uniq'

const createByRoleReducer =
  (entityName) =>
  (state = {}, action) => {
    const pluralEntityName = pluralize(entityName, 2)

    switch (action.type) {
      case `FETCH_${pluralEntityName.toUpperCase()}_SUCCESS`:
        return {
          ...state,
          ...action.entities.reduce((acc, entity) => {
            entity.roles &&
              entity.roles.forEach((role) => {
                if (acc[role]) {
                  acc[role] = uniq([...acc[role], entity.id])
                } else {
                  acc[role] = [entity.id]
                }
              })

            return acc
          }, {}),
        }
      default:
        return state
    }
  }

export default createByRoleReducer
